import isEmpty from './isEmpty.js'
//-------------------------------------------------------------------------------------------------------
// collect unique skill adjs from integrated/active runes for given skill name e.g. stealth, runecasting
//-------------------------------------------------------------------------------------------------------
// NB: results will be applied to skill when processing skill adjs on return
//-------------------------------------------------------------------------------------------------
export default function collectActiveRuneSkillAdjsUnique({ runes = [], skillName }) {
  console.log('-------------------------------------------')
  console.log('IN collectActiveRuneSkillAdjsUnique')
  console.log('skillName = ', skillName)
  //--------------------
  // check got skillName
  //--------------------
  const skill_name = skillName ? skillName : ''
  //----------------------------------------
  // declare map to hold unique adj entries
  //----------------------------------------
  const map = new Map()
  //=========================================================================
  // MAIN INTEGRATED RUNES LOOP
  //=========================================================================
  for (const r of Array.isArray(runes) ? runes : []) {
    console.log('1. LOOP RUNES=====================RUNE = ', r)
    console.log('2. r.name = ', r.name)
    console.log('3. r.display_name = ', r.display_name)
    //-------------------------------------------------
    // check got valid integrated_rune_skill_adjs array
    //-------------------------------------------------
    const adjs = Array.isArray(r?.skill_adjs) ? r.skill_adjs : []
    console.log('4. RUNE SKILL ADJS cnt = ', adjs.length)
    console.log('5. RUNE SKILL ADJS = ', adjs)
    //=========================================================================
    // loop adjs for this rune
    //-------------------------
    for (const adj of adjs) {
      console.log('6. LOOP RUNE SKILL ADJS========ADJ = ', adj)
      //--------------------------
      // skip invalid adj entries
      //--------------------------
      if (!adj) continue
      //------------------
      // match skill_name
      //------------------
      console.log('7. skill_name = ', skill_name, ' vs adj.name = ', adj.name)
      if (skill_name !== adj.name) {
        console.log('+++ SKIP NON-MATCHED SKILL NAME +++')
        continue
      } else {
        console.log('+++ MATCHED SKILL NAME +++')
      }
      //----------------------------------------
      // build unique key from name + adj_value
      //----------------------------------------
      const value = !isEmpty(adj.adj_value) ? adj.adj_value : (adj.value ?? 0)
      const name = (adj.name ?? adj.name ?? '').toString().trim()
      const runeName = (adj.rune_name ?? '').toString().trim()
      const displayName = (adj.display_name ?? '').toString().trim()
      const key = `${skill_name}|${name}|${value}|${runeName}|${displayName}`
      // console.log('--------KEY = ', key)
      //-----------------------
      // add to map if new key
      //-----------------------
      if (!map.has(key)) {
        const entry = {
          adj_value: value,
          // normalise character_item to be the linked
          // CharacterItem id (supports legacy object or id)
          character_item:
            typeof adj.character_item === 'number' || typeof adj.character_item === 'string'
              ? adj.character_item
              : (adj.character_item?.id ?? null),
          id: adj.id,
          name: skill_name,
          rune_name: adj.rune_name,
          display_name: adj.display_name,
          // preserve applied flag where provided; default to true so
          // new integrated rune skill adjs are treated as applied
          applied: adj.applied !== undefined && adj.applied !== null ? !!adj.applied : true,
        }
        console.log('8. ADDING NEW MAP ENTRY:', entry)
        map.set(key, entry)
      }
    }
  }
  //-------------------------------------
  // return unique integrated skill adjs
  //-------------------------------------
  console.log('++++++++++++++++++++++++++++++++++++++++')
  console.log('9. MAP SIZE = ', map.size)
  console.log('10. MAP CONTENTS = ', Array.from(map.entries()))
  console.log('11. MAP VALUES = ', Array.from(map.values()))
  console.log('++++++++++++++++++++++++++++++++++++++++')
  const returnArray = [...Array.from(map.values())]
  console.log('12. RETURN ARRAY = ', returnArray)
  console.log('13. RETURN ARRAY LENGTH = ', returnArray.length)
  return returnArray
}
